import { render, staticRenderFns } from "./HotelMap.vue?vue&type=template&id=95033048&scoped=true"
import script from "./HotelMap.vue?vue&type=script&lang=js"
export * from "./HotelMap.vue?vue&type=script&lang=js"
import style0 from "./HotelMap.vue?vue&type=style&index=0&id=95033048&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95033048",
  null
  
)

export default component.exports